import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@/shared/styles/global.css';

import { App } from './app';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
